import {PrintData} from "./print-data";
import {urlToBase64} from "./url-to-base64";

/**
 * (PDF) 샘플송장 출력데이터
 */
export default new PrintData({
    id: '',
    desc: 'PDF방식 샘플송장출력',

    makeQzDataPromise: (house_id, blno) => {
        let url = '/printer-guide/qz-sample.pdf';

        return urlToBase64(url)
            .then((base64) => {
                return new Promise((resolve, reject) => {
                    let data = [{
                        type: 'pixel',
                        format: 'pdf',
                        flavor: 'base64',
                        data: base64,
                        options: { ignoreTransparency: true }
                    }];
                    resolve(data);

                    console.log('pdf 송장 데이터 생성완료!');

                });
            });


    },
})